module.exports = __webpack_public_path__ + "static/media/Notepad - view.c3c0abc9.jpg";